class TabItem {
  constructor(settings) {
    this.container = settings.container;
    this.item = settings.item;
    this.selected = settings.selected;
    this.mediaQuery = settings.mediaQuery;
    this.tabChangeEvent = null;
    this.trigger = settings.trigger;
    this.observer = null;
    this.index = settings.index;
    this.scrollTarget = settings.scrollTarget;
  }
  bindEvents() {
    this.trigger.addEventListener('click', this.toggleVisibility.bind(this));
    this.container.addEventListener('tabReset', this.resetState.bind(this, false));
    this.container.addEventListener('tabChange', (event) => {
      if (
        event.detail.getAttribute('aria-controls') !== this.trigger.getAttribute('aria-controls')
      ) {
        this.resetState(false);
      }
    });
  }
  // Resets states of other tabs after tab change
  resetState(dispatch) {
    if (this.selected) {
      this.observer.observe(this.item, { attributes: true, childList: false, subtree: false });
    }
    this.selected = false;
    this.setState(dispatch);
  }
  setState(dispatch = true) {
    this.trigger.setAttribute('aria-selected', this.selected);
    this.item.classList.toggle('is-active', this.selected);

    if (dispatch === true) {
      this.container.dispatchEvent(this.tabChangeEvent);
    }
  }
  toggleVisibility() {
    if (!this.selected) {
      this.selected = !this.selected;
      this.setState();
      this.scrollTarget.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }
  mutationCallback() {
    this.observer.disconnect();
  }
  init() {
    this.tabChangeEvent = new CustomEvent('tabChange', {
      detail: this.trigger,
    });

    if (this.selected) {
      this.setState(true);
    }

    this.bindEvents();
    this.observer = new MutationObserver(this.mutationCallback.bind(this));
  }
}

export default TabItem;
